<template>
  <div class="footer">
    公共底部
  </div>
</template>
<script>
// import config from '@/config/index.js'

export default {
  name: 'Footer',
  components: {
  },
  data() {
    return {
      
    }
  }
}
</script>
<style lang="scss" scoped>
  .footer
  {
    color: #fff;
    padding: 0.1rem;
    font-size: 0.2rem;
    background: $--theme_color;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    //暂不显示
    display: none;
  }
</style>
